import { Box, Typography, Grid, Paper, Button, Container } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Layout from "../components/layout/LandingPageLayout";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import InsightsIcon from "@mui/icons-material/Insights";
import VerifiedIcon from "@mui/icons-material/Verified";
import { Link } from "react-router-dom";

const StartupInfo = () => {
  const theme = useTheme();

  return (
    <Layout>
      <Container maxWidth="lg" sx={{ py: 8 }}>
        {/* Title */}
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{ fontWeight: "bold", color: theme.palette.primary.main }}
        >
          Helping Startups Scale Smarter
        </Typography>

        <Typography
          variant="body1"
          align="center"
          sx={{
            maxWidth: 700,
            mx: "auto",
            color: theme.palette.text.secondary,
            mb: 6,
          }}
        >
          Startups need speed, clarity, and compliance. Our AI Accountant helps
          you stay investor-ready, reduce financial complexity, and focus on
          building your product while we handle the numbers.
        </Typography>

        {/* Benefits */}
        <Grid container spacing={4} justifyContent="center">
          <Grid item xs={12} sm={4}>
            <Paper
              elevation={3}
              sx={{
                p: 4,
                textAlign: "center",
                borderRadius: 3,
                transition: "0.3s",
                "&:hover": { transform: "translateY(-6px)", boxShadow: 6 },
              }}
            >
              <AttachMoneyIcon
                sx={{ fontSize: 50, color: theme.palette.primary.main, mb: 2 }}
              />
              <Typography variant="h6" gutterBottom>
                Cost-Effective Accounting
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Save resources by automating bookkeeping, invoicing, and
                compliance instead of hiring a large finance team.
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Paper
              elevation={3}
              sx={{
                p: 4,
                textAlign: "center",
                borderRadius: 3,
                transition: "0.3s",
                "&:hover": { transform: "translateY(-6px)", boxShadow: 6 },
              }}
            >
              <InsightsIcon
                sx={{ fontSize: 50, color: theme.palette.primary.main, mb: 2 }}
              />
              <Typography variant="h6" gutterBottom>
                Investor-Ready Insights
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Generate real-time financial reports, cash flow projections, and
                balance sheets for investor meetings and funding rounds.
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Paper
              elevation={3}
              sx={{
                p: 4,
                textAlign: "center",
                borderRadius: 3,
                transition: "0.3s",
                "&:hover": { transform: "translateY(-6px)", boxShadow: 6 },
              }}
            >
              <VerifiedIcon
                sx={{ fontSize: 50, color: theme.palette.primary.main, mb: 2 }}
              />
              <Typography variant="h6" gutterBottom>
                Compliance Simplified
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Stay compliant with GST, tax filings, and statutory requirements
                without worrying about missing deadlines.
              </Typography>
            </Paper>
          </Grid>
        </Grid>

        {/* CTA */}
        <Box textAlign="center" mt={6}>
          <Button
            component={Link}
            to="/login"
            variant="contained"
            size="large"
            sx={{
              backgroundColor: theme.palette.primary.main,
              "&:hover": { backgroundColor: theme.palette.primary.dark },
              px: 5,
              py: 1.5,
              borderRadius: 3,
              textTransform: "none",
              fontWeight: "bold",
            }}
          >
            Get Started with AI Accounting
          </Button>
        </Box>
      </Container>
    </Layout>
  );
};

export default StartupInfo;
